import { faBarsFilter } from '@fortawesome/pro-regular-svg-icons';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Icon } from '@feathr/components';

interface IProps {
  onClick: () => void;
}

function FilterImportsButton({ onClick }: Readonly<IProps>): JSX.Element {
  const { t } = useTranslation();

  return (
    <Button onClick={onClick} prefix={<Icon icon={faBarsFilter} />}>
      {t('Filters')}
    </Button>
  );
}

export default FilterImportsButton;
